import React from 'react';
import styled from 'styled-components';


const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
	position: relative;
	background-color: #f4f4f4;
	padding: 7px 14px;
	font-size: 11px;
	display: flex;
	flex-direction: row-reverse;
	flex-grow: 0;
	flex-shrink: 0;
	border-bottom: 1px solid #c4c4c4;
	text-align: left;
	height: 65px;
`;
const LinearLevels = styled.div.withConfig({displayName:'-LinearLevels'})`
	flex-grow: 1;
	flex-shrink: 1;
	
`;
const Level = styled.div.withConfig({displayName:'-Level'})`
	display: flex;
	flex-direction: row;
`;

const Label = styled.div.withConfig({displayName:'-Label'})`
	flex-basis: 70px;
	text-align: left;
`;
const Value = styled.div.withConfig({displayName:'-Value'})`
	font-weight: 600;
	text-align: left;
`;
const SideLevel = styled.div.withConfig({displayName:'-SideLevel'})`
	float: left;
	flex-basis: 150px;
	flex-grow: 0;
	flex-shrink: 0;
	padding-right: 12px;
	border-right: 1px solid #707070;
	margin-right: 12px;
	text-align: left;
`;
const SideLevelLabel = styled.div.withConfig({displayName:'-SideLevelLabel'})`
	margin-bottom: 4px;
	text-align: left;
`;
const SideLevelValue = styled.div.withConfig({displayName:'-SideLevelValue'})`
	position: relative;
	font-size: 20px;
	font-weight: 600;
	padding-left: 24px;
	text-align: left;

	&::before{
		content: "";
		display: block;
		position: absolute;
		top: 5px;
		left: 0px;
		width: 17px;
		height: 17px;
		border-radius: ${props =>
			props.color === "darkgreen" ? 0 : 17
		}px;

		background-color: ${props => 
			props.color === "red" ? "#ff0000" : 
			props.color === "yellow" ? "#ffbb39" :  
			props.color === "green" ? "#33be00" :
			props.color === "darkgreen" ? "#006400" :
			props.color === "gray" ? "#828282" : 
			props.color === "white" ? "#ffffff" : 
			""
		};

		background-image: ${props => props.icon ? `url(${props.icon})` : 'none' };
		background-position: center;
		border: ${props => 
			props.color === "red" ? "0px" : 
			props.color === "yellow" ? "0px" :  
			props.color === "green" ? "0px" : 
			props.color === "gray" ? "0px" : 
			props.color === "white" ? "1px solid #dedede" : 
			"0px"
		};
	}
`;

const Header = ({
	lv0, lv1, lv2, lv3, lv4,
	lv3color, lv4color, lv3icon,
	lv0Label, lv1Label, lv2Label, lv3Label, lv4Label,
}) => {
  return (
    <Wrapper>
			<LinearLevels>
				<Level>
					<Label>{lv0Label ?? 'Sito:'}</Label><Value>{lv0 ? lv0 : "-"}</Value>
				</Level>
				<Level>
					<Label>{lv1Label ?? 'Macrolotto:'}</Label><Value>{lv1 ? lv1 : "-"}</Value>
				</Level>
				<Level>
					<Label>{lv2Label ?? 'Subarea:'}</Label><Value>{lv2 ? lv2 : "-"}</Value>
				</Level>
			</LinearLevels>
			{lv4 ? 
				<SideLevel>
					<SideLevelLabel>{lv4Label ?? 'Campione:'}</SideLevelLabel>
					<SideLevelValue color={lv4color}>{lv4 ? lv4 : "-"}</SideLevelValue>
				</SideLevel>
			: lv3 ? 
				<SideLevel>
					<SideLevelLabel>{lv3Label ?? 'Sondaggio:'}</SideLevelLabel>
					<SideLevelValue icon={lv3icon} color={lv3color}>{lv3 ? lv3 : "-"}</SideLevelValue>
				</SideLevel>
			: null }
		</Wrapper>
  )
}

export default Header;
